import { apiSlice } from "../API/apiSlice";

export const projectApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query({
      query: () => "/projects",
    }),
    getProject: builder.query({
      query: (pid) => `/projects/${pid}`
    })
  }),
});

export const { useGetProjectsQuery, useGetProjectQuery } = projectApi;
